import { Typography, styled } from '@mui/material';

export const StyledEmptyDataContainer = styled('div')({
	containerType: 'inline-size',
	width: '100%',
	height: '100%',
	flex: '1',
});

export const StyledEmptyDataWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	textAlign: 'center',
	padding: '16px',
	gap: '16px',
	borderRadius: '12px',
	height: '100%',
	width: '100%',
	position: 'relative',
	boxShadow: '7px 4px 16px 0px #54575E26',

	'&::after': {
		content: '""',
		position: 'absolute',
		zIndex: -1,
		inset: 0,
		padding: '4px',
		borderRadius: '12px',
		background: `linear-gradient(135deg, #FFFFFF 10.43%, rgba(255, 255, 255, 0) 42.07%, rgba(189, 212, 255, 0) 57.34%, ${theme.palette.primary.light} 90.37%)`,
		opacity: 0.4,
		mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
		maskComposite: 'exclude',
	},
}));

export const StyledEmptyDataImageWrap = styled('div')(({ theme }) => ({
	maxWidth: '150px',
	aspectRatio: '1 / 1',
	width: '100%',
	color: theme.palette.primary.light,
	opacity: 0.4,
	overflow: 'hidden',

	'& svg': {
		width: '100%',
		height: '100%',
		maxWidth: '100%',
		maxHeight: '100%',
	},
}));

export const StyledEmptyDataTitle = styled(Typography)({
	fontSize: '20px',
	fontWeight: '600',
	lineHeight: '32px',
	letterSpacing: '0.15px',
});

export const StyledEmptyDataSubTitle = styled(Typography)({
	textWrap: 'balance',
	fontSize: '14px',
	fontWeight: '400',
	lineHeight: '20px',
	letterSpacing: '0.15px',
});
